var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer",attrs:{"color":"background","absolute":""}},[_c('v-spacer'),_c('div',[_vm._v("© PCM Soluções Ltda. "+_vm._s(new Date().getFullYear())+" - "+_vm._s(_vm.version)+" | Todos os direitos reservados.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }